var map = {
	"./Apple.png": 96819,
	"./FoodPandas.png": 39880,
	"./Nike.png": 79791,
	"./Samsung.png": 35989,
	"./Starbucks.png": 84651,
	"./audience.png": 55002,
	"./audio-book.png": 23721,
	"./audio-track.png": 24542,
	"./bandage.png": 69932,
	"./btn_play.png": 93124,
	"./bulb.png": 65945,
	"./color-dollor.png": 56067,
	"./color-gift.png": 12914,
	"./color-instagram.png": 48403,
	"./color-link.png": 12417,
	"./color-star.png": 92263,
	"./color-users.png": 1778,
	"./competitive_icon.png": 97097,
	"./content.png": 46030,
	"./cursor-pointer.png": 6638,
	"./discussion.png": 78129,
	"./elements.png": 98541,
	"./engagementrate.png": 94584,
	"./filled-start.png": 69396,
	"./gallery.png": 47105,
	"./growthrate.png": 66107,
	"./hash.png": 71487,
	"./listing.png": 43206,
	"./music.png": 24490,
	"./pie-chart.png": 1975,
	"./popularformat.png": 23491,
	"./sparkles.png": 17610,
	"./text.png": 12449,
	"./topscore.png": 73941,
	"./travel.png": 50105,
	"./trending-now.png": 7276,
	"./trending.png": 64229,
	"./users.png": 20115,
	"./video-replay.png": 93467,
	"./video.png": 17942
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85546;